import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../../actionLabels/index";
import * as actions from "../../actions";
import axiosMain from "../../../http/axios/axios_main";

function* fetchNotificationsSaga(action) {
  try {
    const { auctionCenterId, userId, notificationFor, auctionType } = action.payload;
    console.log("action.payload", action.payload)

    const url =
      auctionType === "auctionPage"
        ? `/auctionbid/notification/viewnotification/${auctionCenterId}/${userId}/${notificationFor}`
        : `/englishauction/viewenglishauctionnotification/${auctionCenterId}/${userId}/${notificationFor}`;

    const response = yield call(axiosMain.get, url);

    yield put(actions.fetchNotificationsSuccess(response.data));

  } catch (error) {
    yield put(actions.fetchNotificationsFailure(error.message));
  }
}

export function* watchFetchNotifications() {
  yield takeLatest(actionTypes.FETCH_NOTIFICATIONS_REQUEST,
    fetchNotificationsSaga
  )
}
